angular.module('common').factory('Selectors::Pool', function() {
  function getCurrentPool(object) {
    return object && object.currentPool;
  }

  return {
    getCurrentPool: getCurrentPool
  };
});
